<template>
  <div>
    <router-view :key="this.$route.name"></router-view>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      reload: this.reload,
      close: this.close,
    };
  },
  data() {
    return {
      routeState: true,
    };
  },
  methods: {
    reload() {
      this.routeState = false;
      this.$nextTick(() => {
        this.routeState = true;
      });
    },
    close() {
      this.routeState = false;
    },
  },
};
</script>

<style>
</style>